import { BrowserRouter, Route, Routes } from "react-router-dom";

import { useAuth } from "../features/auth/hooks/use-auth";
import Apis from "../pages/Api/Apis";
import CreateOrUpdateApi from "../pages/Api/CreateOrUpdateApi";
import CheckMatch from "../pages/CheckMatch";
import Companies from "../pages/Company/Companies";
import CreateOrUpdateCompany from "../pages/Company/CreateOrUpdateCompany";
import Core from "../pages/Core";
import Dashboard from "../pages/Dashboard";
import Documentation from "../pages/Documentation";
import PrecificadorFipe from "../pages/Internal/PrecificadorFipe";
import CreateOrUpdateDoorRule from "../pages/Internal/PrecificadorFipe/CreateOrUpdateDoorRule";
import GenerateInvoice from "../pages/Invoice/GenerateInvoice";
import ProtectRoutesOnboarding from "../pages/Onboarding";
import OnboardingCreate from "../pages/Onboarding/CreateOnboarding";
import EditSignatoryContact from "../pages/Onboarding/EditContact";
import Onboarding from "../pages/Onboarding/HomeOnboarding";
import ViewLogsProcess from "../pages/Onboarding/LogsProcess";
import OnboardingSaveds from "../pages/Onboarding/SavedOnboarding";
import ViewResponseSignatory from "../pages/Onboarding/ViewResultsOnboarding";
import OrderDetail from "../pages/Order/OrderDetail";
import Orders from "../pages/Order/Orders";
import ListProcessing from "../pages/Processing/ListProcessing";
import NewProcessing from "../pages/Processing/NewProcessing";
import CreateOrUpdateProduct from "../pages/Product/CreateOrUpdateProduct";
import Products from "../pages/Product/Products";
import ReportTemplates from "../pages/Product/ReportTemplates";
import CreateOrUpdateReportTemplate from "../pages/Product/ReportTemplates/CreateOrUpdateReportTemplate";
import CreateOrUpdateResponseClassification from "../pages/Product/ReportTemplates/CreateOrUpdateResponseClassification";
import CreateOrUpdateProvider from "../pages/Provider/CreateOrUpdateProvider";
import Providers from "../pages/Provider/Providers";
import Queries from "../pages/Query/Queries";
import QueryDetail from "../pages/Query/QueryDetail";
import CreateOrUpdateUser from "../pages/User/CreateOrUpdateUser";
import CreateOrUpdateUserWeb from "../pages/User/CreateOrUpdateUserWeb";
import Users from "../pages/User/Users";
import UsersWeb from "../pages/User/UsersWeb";

/**
 * Defines the routes for the application using the 'react-router-dom' library.
 * Sets up routes for different pages such as Companies, Users, Providers, APIs, Products, Queries, Invoice, Processing, and Documentation.
 * Each route is associated with a specific page component that will be rendered when the route is accessed.
 * @returns The JSX element that defines the routes for the application.
 */

export function OtherRoutes() {
	const { user } = useAuth();

	return (
		<BrowserRouter>
			<Routes>
				<Route path="/" element={<Core />}>
					<Route index element={<Dashboard />} />
					<Route path="*" element={<Dashboard />} />
					{/* Companies */}
					<Route path="/companies" element={<Companies />} />
					<Route path="/company/:id" element={<CreateOrUpdateCompany />} />
					<Route path="/new-company" element={<CreateOrUpdateCompany />} />
					{/* Users */}
					{/* <Route path='/users' element={<AdmUsers/>}/> */}
					<Route path="/users/:id" element={<Users />} />
					{/* <Route path='/new-user' element={<CreateOrUpdateUser/>}/> */}
					<Route
						path="/new-user/:company_id"
						element={<CreateOrUpdateUser />}
					/>
					<Route path="/user/:id" element={<CreateOrUpdateUser />} />
					<Route path="/new-user-web" element={<CreateOrUpdateUserWeb />} />
					<Route path="/user-web/:id" element={<CreateOrUpdateUserWeb />} />
					<Route path="/users-web" element={<UsersWeb />} />
					{/* Orders */}
					<Route path="/pedidos" element={<Orders />} />
					<Route path="/pedido/:id" element={<OrderDetail />} />
					{/* Providers */}
					<Route path="/providers" element={<Providers />} />
					<Route path="/provider/:id" element={<CreateOrUpdateProvider />} />
					<Route path="/new-provider" element={<CreateOrUpdateProvider />} />
					{/* APIs */}
					<Route path="/apis/:id" element={<Apis />} />
					<Route path="/new-api/:provider_id" element={<CreateOrUpdateApi />} />
					<Route path="/api/:id" element={<CreateOrUpdateApi />} />
					{/* Products */}
					<Route path="/products" element={<Products />} />
					<Route path="/new-product" element={<CreateOrUpdateProduct />} />
					<Route path="/product/:id" element={<CreateOrUpdateProduct />} />
					{/* Report Templates */}
					<Route path="/report-templates" element={<ReportTemplates />} />
					<Route
						path="/report-template/:id"
						element={<CreateOrUpdateReportTemplate />}
					/>
					<Route
						path="/new-report-template"
						element={<CreateOrUpdateReportTemplate />}
					/>
					<Route
						path="/new-response-classification"
						element={<CreateOrUpdateResponseClassification />}
					/>
					<Route
						path="/response-classification/:id"
						element={<CreateOrUpdateResponseClassification />}
					/>
					{/* Queries */}
					<Route path="/queries" element={<Queries />} />
					<Route path="/query/:id" element={<QueryDetail />} />
					{/* Invoice */}
					<Route path="/generate/invoice" element={<GenerateInvoice />} />
					{/* Processing */}
					<Route path="/list-processing" element={<ListProcessing />} />
					<Route path="/new-processing" element={<NewProcessing />} />
					{/* Documentation */}
					<Route path="/documentation" element={<Documentation />} />
					{/* Onboarding */}
					<Route
						path="/onboarding"
						element={
							<ProtectRoutesOnboarding>
								<Onboarding />
							</ProtectRoutesOnboarding>
						}
					/>

					<Route
						path="/onboarding/saved"
						element={
							<ProtectRoutesOnboarding>
								<OnboardingSaveds />
							</ProtectRoutesOnboarding>
						}
					/>

					<Route
						path="/onboarding/saved/edit/:id_onboarding"
						element={
							<ProtectRoutesOnboarding>
								<OnboardingCreate />
							</ProtectRoutesOnboarding>
						}
					/>

					<Route
						path="/onboarding/create-onboarding"
						element={
							<ProtectRoutesOnboarding>
								<OnboardingCreate />
							</ProtectRoutesOnboarding>
						}
					/>

					<Route
						path="/onboarding/edit-contact/:id_signatory"
						element={
							<ProtectRoutesOnboarding>
								<EditSignatoryContact />
							</ProtectRoutesOnboarding>
						}
					/>

					<Route
						path="/onboarding/view-response/:id_signatory"
						element={
							<ProtectRoutesOnboarding>
								<ViewResponseSignatory />
							</ProtectRoutesOnboarding>
						}
					/>
					<Route
						path="/onboarding/logs-process/:id_signatory"
						element={
							<ProtectRoutesOnboarding>
								<ViewLogsProcess />
							</ProtectRoutesOnboarding>
						}
					/>
					<Route path="/precificador-fipe" element={<PrecificadorFipe />} />
					<Route path="/new-door-rule" element={<CreateOrUpdateDoorRule />} />
					<Route path="/door-rule/:id" element={<CreateOrUpdateDoorRule />} />
					{/* CheckMatch */}
					{user?.checkmatch === true ? (
						<Route path="/check-match" element={<CheckMatch />} />
					) : (
						<></>
					)}
				</Route>
			</Routes>
		</BrowserRouter>
	);
}
